import Layout from "../components/Layout";

export default function Cenital() {
    return (
        <Layout title="Lee nuestro CENITAL de cada mes">
            <iframe title="cenital" src="https://drive.google.com/file/d/1xqCrAypdG3QfEpD1ij-4l8d6TDMjLUmz/preview" width="100%" height="600" allow="autoplay"></iframe>
        </Layout>
    )
}